<template>
  <div class="aboutUs">
    <div class="boxCenter">
      <div class="insideBanner">
        <img :src="feedBanner" alt="TINDOE坦途"/>
      </div>
      <div class="addFeedBox">
        <el-input
          type="textarea"
          :maxlength="500"
          :rows="6"
          placeholder="我想说..."
          v-model="addMessageStr">
        </el-input>
        <p style="margin-top: 5px;font-size: 12px;color: #999;">留言字数限制500字</p>
        <div class="addBtn">
          <span class="spanClassify">选择分类</span> 
          <el-select v-model="addMessageType" size="mini" placeholder="请选择" style="width: 100px;">
            <el-option v-for="(item,index) in typeList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <span v-if="userData" class="btn" @click="addMessage">发表</span>
          <span class="loginAuth" v-if="!userData"><span class="loginbtn" @click="goToLogin">登录后</span>评论</span>
        </div>
        <!-- <div style="margin-top: 20px;"><el-button disabled>确 认</el-button></div> -->
      </div>
      <div class="feedList">
        <div class="feedListContent">
          <div class="listTab">
            <p @click="sortChange(1)">最新<span :class="{'active':messageSort == 1}"></span></p>
            <p @click="sortChange(2)">最热<span :class="{'active':messageSort == 2}"></span></p>
          </div>
          <div class="listContent">
            <ul class="listClassify">
              <li :class="{'active' : messageType==0}" @click="checkMessageByType(0)">全部</li>
              <li :class="{'active' : messageType==item.id}" :title="item.name" @click="checkMessageByType(item.id)" v-for="(item,index) in typeList" :key="index">{{item.name}}</li>
            </ul>
            <div class="feedItemBox">
              <div class="feedItem" v-for="(item,index) in messageList" :key="index">
                <div class="imgBox"><img :src="item.headPic"></div>
                <div class="infoBox">
                  <p class="p1">{{item.nickname}}</p>
                  <p class="p2">{{item.createDate.substring(0,19)}}</p>
                  <p class="p3">{{item.content}}</p>
                </div>
                <div class="interaction">
                  <div class="interaction-num">
                    <span class="span1" :class="{'active':item.isLike == 2}" @click="giveToYes(item)">{{item.likeSum}}</span>
                    <span class="span2" @click="gitToComment(item)">{{item.commentSum}}</span>
                  </div>
                  <div class="interaction-feedback" v-if="item.show" @mouseenter="curItemChange(item)">
                    <p class="commentBack" v-if="item.replyObj">回复{{item.replyObj.nickname}}：</p>
                    <el-input
                      type="textarea"
                      :maxlength="200"
                      :ref="'input'+item.id"
                      :rows="3"
                      placeholder="我想说..."
                      v-model="item.feedBackStr">
                    </el-input>
                    <p style="margin-top: 5px;font-size: 12px;color: #999;">评论字数限制200字</p>
                    <div class="loginTip">
                      <span v-if="!userData"><span class="loginbtn" @click="goToLogin">登录后</span>评论</span>
                      <span v-if="userData">
                        <el-button size="mini" type="warning" round @click="confirmComment(index)">提交</el-button>
                        <!-- <el-button size="mini" round @click="cancleReply">取消</el-button> -->
                      </span>
                    </div>
                    <div class="messageItemBox">
                      <div class="messageItem" v-for="(row,index) in item.commentList" :key="index">
                        <div class="userImg"><img :src="row.headPic"></div>
                        <div class="messageInfo">
                          <p class="p1">{{row.nickname}}<span>{{row.createDate.substring(0,19)}}</span></p>
                          <p class="p2" v-if="row.replyNickname">回复 <span style="color: #5680F9">{{row.replyNickname}}</span>： {{row.comment}}</p>
                          <p class="p2" v-else>{{row.comment}}</p>
                          <span class="callBack" @click="callBack(row)">回复</span>
                        </div>
                      </div>
                    </div>
                    <div style="padding:18px 0 9px;text-align: center" v-if="item.commentTotal>0">
                      <el-pagination
                        background
                        layout="prev, pager, next"
                        @current-change="handleCurrentChange"
                        :current-page="item.commentIndex"
                        :page-size="3"
                        :total="item.commentTotal">
                      </el-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="messageList.length == 0" style="text-align: center;padding-top: 100px;">暂无留言</div>
              <div class="checkMoreFeed" v-if="messageIndex != pages && pages>0" @click="checkMoreMessage">查看更多</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import eventVue from '../bus.js'
  export default {
    data(){
      return {
        dataObj:null,
        typeList:[],
        feedBanner:'',

        addMessageStr:'',
        addMessageType:'',

        //feedBackStr:'',

        messageIndex:1,
        pages:1,
        messageNum:10,
        messageType:0,
        messageSort:1,
        messageList:[],

        // commentIndex:1,
        // commentTotal:0,
        // commentList:[],
        curMessageObj:null,
      }
    },
    computed: {
      userData() {
        return this.$store.state.userData
      }
    },
    watch: {
      userData: {
        handler(newName, oldName){
          if (newName) {
            this.getMessageList()
          }
        },
        immediate: true
      }
    },
    created(){
      this.loadBannerData()
      this.getMessageList()
      this.getMessageType()
    },
    mounted(){
      
    },
    methods:{
      //更改消息列表查询列表
      checkMessageByType(id){
        this.messageType = id
        this.messageIndex = 1
        this.getMessageList()
      },
      sortChange(sort){
        this.messageSort = sort
        this.messageIndex = 1
        this.getMessageList()
      },
      loadBannerData(){
        this.$https.get('/api/config').then((response)=>{
          this.dataObj = response.data
          for(let i=0;i<response.data.length;i++){
            let item = response.data[i]
            if(item.id == 14){
              this.feedBanner =  item.msg
              continue
            }
          }
        }).catch((error) => {});
      },
      //获取所有分类列表
      getMessageType(){
        this.$https.get('/api/messageType').then((response)=>{
          this.typeList = response.data
        }).catch((error) => {});
      },
      //获取留言列表
      getMessageList(){
        let _url = `/api/message/pageIndex/${this.messageIndex}/pageNum/10?messageTypeId=${this.messageType==0?'':this.messageType}&sort=${this.messageSort}`
        if(this.userData){
          _url = `/api/message/pageIndex/${this.messageIndex}/pageNum/10?messageTypeId=${this.messageType==0?'':this.messageType}&sort=${this.messageSort}&memberId=${this.userData.id}`
        }
        this.$https.get(_url).then((res)=>{
          this.pages = res.data.pages
          res.data.records.forEach(item => {
            item.show = false
            item.commentList = []
            item.commentIndex = 1
            item.commentTotal = 0
            item.replyObj = null,
            item.feedBackStr = ""
          })
          if(this.messageIndex == 1){
            this.messageList = res.data.records
          }else{
            this.messageList = this.messageList.concat(res.data.records)
          }
        }).catch((error) => {});
      },
      //查看跟多
      checkMoreMessage(){
        this.messageIndex+=1
        this.getMessageList()
      },
      //新增留言
      addMessage(){
        if (this.addMessageStr == "") {
          this.$message.warning('请输入留言内容')
          return
        }
        if (this.addMessageStr.length > 500) {
          this.$message.warning('留言内容不能超过500字')
          return
        }
        if (this.addMessageType == "") {
          this.$message.warning('请选择留言类型')
          return
        }
        let data = {
          content:this.addMessageStr,
          memberId:this.userData.id,
          messageTypeId:this.addMessageType
        }
        this.$https.post('/api/message',data).then((response)=>{
          this.$message.success('新增成功')
          this.addMessageStr = ""
          this.addMessageType = ""
          this.getMessageList()
        }).catch((error) => {});
      },
      handleCurrentChange(index){
        this.curMessageObj.commentIndex = index
        this.getCommentList(this.curMessageObj)
      },
      goToLogin(){
        eventVue.$emit("callLogin")
      },
      //点赞 和取消赞
      giveToYes(item){
        if(!this.userData){
          eventVue.$emit("callLogin")
          return
        }
        this.$https.post(`/api/message/like?messageId=${item.id}&memberId=${this.userData.id}`,{}).then((res)=>{
          if (res.code == 0) {
            item.isLike = (item.isLike == 1 ? 2 :1)
            if (item.isLike == 1) {
              item.likeSum -= 1
            }else{
              item.likeSum += 1
            }
          }
        }).catch((error) => {});
      },
      //评论、查看评论
      gitToComment(item){
        item.show = !item.show
        if(item.show && item.commentSum > 0 && item.commentList.length == 0){
          this.getCommentList(item)
        }
      },
      //获取评论列表
      getCommentList(item,index){
        this.$https.get(`/api/message/id/${item.id}/pageIndex/${item.commentIndex}/pageNum/3`).then((response)=>{
          item.commentList = response.data.records
          item.commentTotal = response.data.total
          if (!isNaN(index)) {
            this.messageList[index].commentSum = response.data.total
            this.$forceUpdate()
          }
        }).catch((error) => {});
      },
      //当前操作的评论对象
      curItemChange(item){
        this.curMessageObj = item
      },
      //回复留言
      callBack(row){
        this.curMessageObj.replyObj = row
        let name = 'input'+this.curMessageObj.id
        this.$refs[name][0].focus();
      },
      //取消留言编辑信息
      cancleReply(){
        this.curMessageObj.replyObj = null
        this.curMessageObj.feedBackStr = ""
      },
      //确认评论
      confirmComment(index){
        if (this.curMessageObj.feedBackStr == "") {
          this.$message.warning('请输入回复内容')
          return
        }
        let data = {
          comment: this.curMessageObj.feedBackStr,
          memberId: this.userData.id,
          messageId: this.curMessageObj.id,
          replyMemberId: this.curMessageObj.replyObj?this.curMessageObj.replyObj.memberId:''
        }
        this.$https.post('/api/message/addMessageComment',data).then((response)=>{
          this.$message.success('回复成功')
          this.curMessageObj.replyObj = null
          this.curMessageObj.feedBackStr = ""
          this.getCommentList(this.curMessageObj,index)
        }).catch((error) => {});
      }
    }
  }
</script>

<style scoped>
  .insideBanner{
    width: 1200px;
    height: 275px;
    position: relative;
  }
  .insideBanner img{
    width: 100%;
    height: 100%;
  }
  .addFeedBox{
    padding: 33px 33px 20px;
    background: #FFFFFF;
    margin: 18px 0 0px;
    overflow: hidden;
  }
  .addBtn{
    overflow: hidden;
    line-height: 48px;
    padding-top: 12px;
    font-size: 14px;
    color: #333333;
  }
  .addBtn .spanClassify{
    padding-left: 20px;
    background-image: url("../assets/images/c-icon.png");
    background-repeat: no-repeat;
    background-position: left center;
  }
  .addBtn .loginAuth{
    float: right;
  }
  .addBtn .loginAuth .loginbtn{
    color: #5680f9;
    margin-right: 10px;
    cursor: pointer;
  }
  .addBtn .btn{
    width: 64px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background: #FFCD30;
    padding: 0px;
    border-radius: 4px;
    font-size: 14px;
    color: #ffffff;
    float: right;
    cursor: pointer;
  }
  .feedList{
    padding: 8px 0 20px;
  }
  .feedListContent{
    background: #ffffff;
    padding: 0 34px;
  }
  .listTab{
    height: 105px;
    line-height: 105px;
    text-align: center;
  }
  .listTab p{
    display: inline-block;
    position: relative;
    margin: 0 21px;
    padding: 0 3px;
    cursor: pointer;
  }
  .listTab p span{
    display: block;
    width: 37px;
    height: 4px;
    background: #ffffff;
    border-radius: 2px;
    position: absolute;
    left: 1px;
    bottom: 34px;
  }
  .listTab p span.active{
    background: #5680F9;
  }
  .listContent{
    overflow: hidden;
  }
  .listClassify{
    float: left;
    margin-left: 0px;
  }
  .listClassify li{
    width: 148px;
    height: 36px;
    line-height: 36px;
    background-color: #ffffff;
    border-radius: 4px;
    padding-left: 38px;
    background-image: url("../assets/images/c-icon1hover.png");
    background-repeat: no-repeat;
    background-position: 11px 10px;
    color: #666666;
    cursor: pointer;
    font-size: 14px;
    margin-bottom: 12px;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }
  .listClassify li:hover,.listClassify li.active{
    background-image: url("../assets/images/c-icon1.png");
    background-color: #5680F9;
    color: #ffffff;
  }
  .feedItemBox{
    float: left;
    width: 880px;
    background: #FAFAFA;
    padding: 20px;
    margin-left: 25px;
  }
  .feedItem{
    padding: 10px;
    background: #ffffff;
    margin-bottom: 20px;
  }
  .feedItem .imgBox{
    width: 40px;
    height: 40px;
    border-radius: 40px;
    margin: 10px 0 0 15px;
    border: 1px solid #D9D9D9;
    overflow: hidden;
    float: left;
  }
  .feedItem .imgBox img{
    width: 100%;
    height: 100%;
  }
  .feedItem .infoBox{
    padding-left: 75px;
    min-height: 155px;
  }
  .feedItem .infoBox .p1{
    line-height: 24px;
    color: #333333;
    font-size: 16px;
    margin-top: 6px;
  }
  .feedItem .infoBox .p2{
    line-height: 24px;
    color: #666666;
    font-size: 12px;
  }
  .feedItem .infoBox .p3{
    padding: 8px 0px;
    line-height: 21px;
    color: #333333;
    font-size: 14px;
  }
  .interaction{
    border-top: 1px solid #EEEEEE
  }
  .interaction-num{
    height: 46px;
    position: relative;
  }
  .interaction-num .span1{
    position: absolute;
    top: 20px;
    left: 250px;
    padding-left: 25px;
    background-image: url("../assets/images/yes.png");
    background-repeat: no-repeat;
    background-position: left center;
    font-size: 16px;
    color: #666666;
    cursor: pointer;
  }
  .interaction-num .span1.active{
    background-image: url("../assets/images/yesactive.png");
  }
  .interaction-num .span2{
    position: absolute;
    top: 20px;
    left: 632px;
    padding-left: 25px;
    background-image: url("../assets/images/message.png");
    background-repeat: no-repeat;
    background-position: left center;
    font-size: 16px;
    color: #666666;
    cursor: pointer;
  }
  .interaction-feedback{
    padding: 0 16px 0 74px;
  }
  .loginTip{
    text-align: right;
    height: 60px;
    line-height: 60px;
    font-size: 14px;
    color: #333;
  }
  .loginTip .loginbtn{
    color: #5680f9;
    margin-right: 10px;
    cursor: pointer;
  }
  .messageItemBox{
    background: #FAFAFA;
    padding: 0 20px;
  }
  .messageItem{
    min-height: 90px;
    padding-top: 1px;
    position: relative;
  }
  .messageItem + .messageItem{
    border-top: 1px solid #EEEEEE;
  }
  .messageItem .userImg{
    width: 40px;
    height: 40px;
    border-radius: 40px;
    margin: 20px 0px 0 10px;
    border: 1px solid #D9D9D9;
    overflow: hidden;
    float: left;
  }
  .messageItem .userImg img{
    width: 100%;
    height: 100%;
  }
  .messageItem .messageInfo{
    padding-left: 70px;
    padding-top: 1px;
  }
  .messageItem .messageInfo .p1{
    line-height: 28px;
    color: #333;
    font-size: 16px;
    padding-top: 10px;
  }
  .messageItem .messageInfo .p1 span{
    font-size: 12px;
    color: #666;
    margin-left: 10px;
  }
  .messageItem .messageInfo .p2{
    font-size: 14px;
    color: #333;
    line-height: 21px;
    padding-top: 5px;
  }
  .messageItem .callBack{
    position: absolute;
    right: 0px;
    top: 24px;
    cursor: pointer;
    font-size: 14px;
    color: #5680F9;
  }
  .checkMoreFeed{
    width: 184px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #FFFFFF;
    border: 1px dashed #5680F9;
    border-radius: 4px;
    font-size: 16px;
    color: #5680F9;
    cursor: pointer;
    margin: 0 auto;
  }
  .commentBack{
    font-size: 14px;
    color: #999999;
    line-height: 21px;
  }
</style>



// WEBPACK FOOTER //
// src/components/feedback.vue